import {
  CategoryProps,
  DonorProps,
  GenderProps,
  ItemProps,
  NonDonatedItemProps,
  ProductProps,
  SelectorOptionProps,
  SizeProps,
} from "../types/interfaces";

export const ITEM_INITIAL_STATE: ItemProps = {
  gender: null,
  product: null,
  category: null,
  size: null,
  donor: null,
  // color: "",
  donorSource: null,
};

export const NON_DONATED_ITEM_INITIAL_STATE: NonDonatedItemProps = {
  supply: null,
  vendor: null,
};

export const GENDER_INITIAL_STATE: GenderProps = {
  id: 0,
  label: "",
  value: "",
  categories: [],
};

export const PRODUCT_INITIAL_STATE: ProductProps = {
  id: 0,
  label: "",
  value: "",
  sizes: [],
};

export const CATEGORY_INITIAL_STATE: CategoryProps = {
  id: 0,
  label: "",
  value: "",
  products: [],
};

export const SIZE_INITIAL_STATE: SizeProps = {
  id: 0,
  label: "",
  value: "",
};

export const DONOR_INITIAL_STATE: DonorProps = {
  id: 0,
  label: "",
  value: "",
  donorsource: [],
};

export const DONOR_SOURCE_INITIAL_STATE: SizeProps = {
  id: 0,
  label: "",
  value: "",
};

export const SELECTOR_OPTIONS_INITIAL_STATE: SelectorOptionProps = {
  products: [],
  categories: [],
  sizes: [],
  donors: [],
  donorSources: [],
};
